<template>
  <div class="Drawer__container">
    <transition name="popup-slide" :duration="500">
      <section class="Drawer__content bg-white" :class="$mq" v-if="open">
        <slot></slot>
      </section>
    </transition>

    <div class="Drawer__overlay" @click="$emit('close')" v-if="open"></div>
  </div>
</template>

<script>
import { addClass, removeClass } from "@/lib/bodyClass.js"

export default {
  name: "Drawer",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    open: function () {
      if (this.open) {
        addClass("overflow-y-hidden")
        addClass("sm:overflow-y-scroll")
      } else {
        removeClass("overflow-y-hidden")
        removeClass("sm:overflow-y-scroll")
      }
    },
  },
}
</script>

<style>
.Drawer__content {
  @apply fixed left-0 bottom-0 w-full;
  z-index: 1501;
}

.Drawer__overlay {
  @apply fixed top-0 left-0 w-full h-full;
  background-color: #0009;
  z-index: 150;
}
</style>
